import React from 'react'
import { Card, CardBody, Container } from 'reactstrap'
import ErrorBoundary from 'components/ErrorBoundary'
import ConfigurationsTabs from './ConfigurationTabs'
import CoveredEntityConfig from './CoveredEntityConfig';
import useContextService from 'hooks/useContextService';

const Configurations = (props) => {
    const { orgId } = props;
    return (
        <div>
            <Container fluid className='width_info'>

                        <ErrorBoundary >
                        <CoveredEntityConfig orgId={orgId} />

                            {/* <SearchContainer manvalPharmacy={manvalPharmacy} /> */}
                        </ErrorBoundary>
                    
            </Container>
        </div>
    );
};
export default Configurations
